import React, { useState, useEffect } from "react";
import { doc,getDocs, getDoc, updateDoc, setDoc, collection, addDoc } from "firebase/firestore";
import { auth, txtdb } from "../../firebase-config";
import { useNavigate } from "react-router-dom";

function CopyTradeModal({ trader, onClose }) {
  const [wallets, setWallets] = useState([]);
  const [selectedWallet, setSelectedWallet] = useState("");
  const [balance, setBalance] = useState(0);
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

useEffect(() => {
  const fetchWallets = async () => {
    const currentUser = auth.currentUser;
    if (!currentUser) return;

    const balancesRef = collection(txtdb, "users", currentUser.uid, "balances");
    const balancesSnap = await getDocs(balancesRef);

    if (balancesSnap.empty) {
      // No balances created yet
      setWallets([]);
      return;
    }

    const fetchedWallets = balancesSnap.docs.map((doc) => ({
      name: doc.id,
      symbol: doc.id,
      balance: doc.data().balance || 0,
    }));

    setWallets(fetchedWallets);
  };

  fetchWallets();
}, []);


  const handleWalletSelect = (wallet) => {
    setSelectedWallet(wallet.symbol);
    setBalance(wallet.balance);
  };

  const handleCopyTrade = async () => {
    const currentUser = auth.currentUser;
    if (!currentUser) return;

    if (!selectedWallet) return setError("Please select a wallet.");
    if (!amount || amount < 100) return setError("Minimum trade amount is $100.");
    if (amount > balance) return setError("Insufficient balance.");

    setIsLoading(true);
    setError("");

    try {
      // Deduct from wallet
      const userRef = doc(txtdb, "users", currentUser.uid);
      const userSnap = await getDoc(userRef);
      const userData = userSnap.data();
const balanceRef = doc(txtdb, "users", currentUser.uid, "balances", selectedWallet);


await updateDoc(balanceRef, {
  balance: balance - Number(amount),
});


      // Create trade document
      const tradeData = {
        traderName: trader.name,
        winRate: trader.winRate,
        investedAmount: Number(amount),
        startDate: new Date(),
        endDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
        durationDays: 30,
        status: "active",
        asset: selectedWallet,
        userId: currentUser.uid,
        currentAmount: Number(amount),
        createdAt: new Date(),
      };

      await addDoc(collection(txtdb, "users", currentUser.uid, "copyTrades"), tradeData);

      // Add transaction record
      await addDoc(collection(txtdb, "users", currentUser.uid, "transactions"), {
        type: "Copy Trade",
        category: "Copy Trade",
        amount: Number(amount),
        trader: trader.name,
        asset: selectedWallet,
        date: new Date().toISOString(), // ISO format date
        transactionStatus: "Started",
      description: `Copy Traded ${trader.name}`,
      });

      onClose();
    } catch (error) {
      console.error("Error copying trade:", error);
      setError("Failed to start trade. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2 >Copy {trader.name}</h2>
        <p className="win-rate">Win Rate: {trader.winRate}%</p>

        <div className="wallets">
      <p className="select-wallet">Select Wallet:</p>

      {wallets.length === 0 ? (
        <div className="no-wallets">
          <p>Add funds to start copy trading.</p>
          <button className="add-funds-btn" onClick={() => navigate("/deposits")}>
            Add Funds
          </button>
        </div>
      ) : (
        <div className="wallet-options">
          {wallets.map((w) => (
            <button
              key={w.symbol}
              className={selectedWallet === w.symbol ? "selected" : ""}
              onClick={() => handleWalletSelect(w)}
            >
              {w.name} (${w.balance})
            </button>
          ))}
        </div>
      )}
    </div>


        <input
          type="number"
          placeholder="Enter Amount ($100 minimum)"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />


        <div className="actions">
          <button onClick={onClose} className="cancel">Cancel</button>
          <button onClick={handleCopyTrade} disabled={isLoading}>
            {isLoading ? "Starting..." : "Start Copy Trade"}
          </button>
        </div>

        {error && <p className="error">{error}</p>}

        <p className="small-text">
          Trade lasts for 30 days. Profit grows daily according to win rate.
        </p>
      </div>
    </div>
  );
}

export default CopyTradeModal;
